import React from "react";

function ListTags() {
  return <div></div>;
}

export default ListTags;
